<template>
  <div class="animated fadeIn">
    <MainChartTable :set_data=set_data :selectedData=adrequest />
  </div>
</template>
<script>
import MainChartTable from '../MainChartTable'
export default {
    name: 'Ad_Request',
    props:[ 'setData'],
    components:{
        MainChartTable
    },
    data () {
        return {
            set_data:0,
            adrequest:'ad_requests',
        }
    },
    watch :{
        setData(nValue,oValue){
            this.set_data++
            this.adrequest='ad_requests'
        }
    }
}
</script>
